var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 90,
    viewBox: "0 0 115 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 68L53.8234 23.3985C54.4158 22.8672 55.3134 22.8672 55.9059 23.3985L71.2795 45.3847V34.4351C71.2795 33.5736 71.978 32.8753 72.8394 32.8753H83.2341C84.0955 32.8753 84.794 33.5736 84.794 34.4351V57.502L96.5024 68",
    stroke: "#FF0000",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumFace);
export default __webpack_public_path__ + "static/media/mediumFace.73dadf598beca8214f6e98c8a9e319fb.svg";
export { ForwardRef as ReactComponent };